const dateUtils = {
  calculateAge(birthDate) {
    if (birthDate != null) {
      const currentYear = new Date().getYear();
      const currentMonth = new Date().getMonth();

      const dobYear = new Date(birthDate).getYear();
      const dobMonth = new Date(birthDate).getMonth();

      //get years
      let yearAge = currentYear - dobYear;

      let monthAge = 0;
      //get months
      if (currentMonth >= dobMonth)
        //get months when current month is greater
        monthAge = currentMonth - dobMonth;
      else {
        yearAge--;
        monthAge = 12 + currentMonth - dobMonth;
      }

      const result = yearAge + monthAge * 0.01;
      return result.toFixed(2);
    } else {
      return 0;
    }
  },
};

export default dateUtils;
